//framework
import React from "react";
import PropTypes from "prop-types";

//styles
import styles from "./GameScreen.module.scss";

//assets
import { IMAGES } from "constants/constants";

// Usage:
// <TitleFrame className={styles.titleScreen} bgImage={someImage}>
//   ...children...
// </TitleFrame>
export default function GameScreen({ bgImage = IMAGES.HOST.bigScreenBg, className = "", children }) {
    return (
        <div
            className={`${styles.frame} ${className}`}
            style={{ "--frame-bg": `url(${bgImage})` }}
            aria-hidden={false}
        >
            <div className={styles.inner}>
                {children}
            </div>
        </div>
    );
}

GameScreen.propTypes = {
    bgImage: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
};
